import { render } from "./TaskSettingsDates.vue?vue&type=template&id=f2f472be"
import script from "./TaskSettingsDates.vue?vue&type=script&lang=js"
export * from "./TaskSettingsDates.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsDates.vue?vue&type=style&index=0&id=f2f472be&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__